<template>
  <v-app>
    <v-row class="justify-center ma-0">
      <div class="d-flex justify-center align-center flex-column" v-if="isLoading">
        <p>Carregando...</p>
        <v-progress-circular indeterminate color="primary" class="mb-0"></v-progress-circular>
      </div>
      <v-col
        class="col-12 col-sm-12 col-md-11 col-lg-11"
        v-if="!isLoading"
        :class="{'pt-3': $vuetify.breakpoint.smAndDown, 'pt-5': $vuetify.breakpoint.mdAndUp}"
      >
        <v-container>
          <v-row class="justify-center align-center my-2" v-if="category == 'psychologist'">
            <v-col class="col-12 col-md-5">
              <h2 class="mx-2 text-center text-md-left">Perfil</h2>
            </v-col>
            <v-col class="col-12 col-md-5">
              <v-row
                :class="{'justify-space-around': $vuetify.breakpoint.smAndDown, 'justify-end': $vuetify.breakpoint.mdAndUp}"
              >
                <v-btn
                  color="gray"
                  to="/change-password"
                  dark
                  :class="{'mr-3': $vuetify.breakpoint.mdAndUp}"
                >{{$t('pageProfile.btnSenha')}}</v-btn>
                <v-btn color="gray" dark to="edit-profile">Editar Perfil</v-btn>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="justify-center align-center my-2" v-if="category != 'psychologist'">
            <v-col class="col-md-5">
              <v-row class="aling-center ma-0">
                <v-img :src="require('../../assets/ear_32x32.png')" max-width="32" max-height="32"></v-img>
                <h2 class="mx-2 text-center text-md-left">Psicólogo</h2>
              </v-row>
            </v-col>
            <v-col class="col-md-5 text-sm-right">
              <v-btn color="secondary" :to="{path: '/psicologo/scheduling/'+ cod}">AGENDAR CONSULTA</v-btn>
            </v-col>
          </v-row>
          <v-row class="justify-center">
            <v-col class="col-12 col-md-5 col-lg-5 px-3">
              <v-col class="col-12 d-flex align-center justify-end">
                <div
                  class="pl-12"
                  style="background: #FFFDE3; padding: 13px 0; border-radius: 12px; width: calc(100% - 46px); position: relative;"
                >
                  <div style="position: absolute; left: -50px; top: 0">
                    <v-avatar size="90">
                      <v-img v-if="user.photo != ''" :src="user.photo">
                        <template v-slot:placeholder>
                          <v-row fill-height align-center justify-center ma-0>
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>

                      <v-img v-if="user.photo == ''" :src="require('../../assets/no-image.png')"></v-img>
                    </v-avatar>
                  </div>
                  <p class="mb-2 font-weight-bold subheading">{{ user.name }}</p>
                  <p class="ma-0">
                    <span class="font-weight-bold">Nacionalidade:</span>
                    {{ user.country }}
                  </p>
                </div>
              </v-col>
              <div class="d-flex mt-4">
                <v-col class="col-6 ml-2">
                  <p>
                    <span class="font-weight-bold">Sexo:</span>
                    {{ user.gender }}
                  </p>
                </v-col>
                <v-col class="col-6">
                  <p>
                    <span class="font-weight-bold">Nascimento:</span>
                    {{ user.date_birth }}
                  </p>
                </v-col>
              </div>
              <v-divider></v-divider>
              <div class="d-flex mt-4">
                <v-col class="col-6 ml-2">
                  <p>
                    <span class="font-weight-bold">{{$t('pageProfile.labelDestrito')}}:</span>
                    {{ user.state }}
                  </p>
                </v-col>
                <v-col class="col-6">
                  <p>
                    <span class="font-weight-bold">Cidade:</span>
                    {{ user.city }}
                  </p>
                </v-col>
              </div>
              <v-divider></v-divider>
              <div>
                <h3 class="my-4">{{$t('pageProfile.titleContato')}}</h3>
                <div>
                  <div class="mb-3 box-contact d-flex align-center" v-if="user.email">
                    <span>Email</span>
                    <v-img :src="require('../../assets/icon-mail.svg')" width="28px" class="mr-2"></v-img>
                    <p>{{ user.email }}</p>
                  </div>
                  <v-divider class="mb-3"></v-divider>

                  <div
                    class="mb-3 box-contact d-flex align-center"
                    style="justify-content: center;"
                  >
                    <span>Habilitações Académicas:</span>
                    <p>{{ user.academic_degree }}</p>
                    <!-- <v-img
                      :src="require('../../assets/md-star.svg')"
                      width="40px"
                      class="mx-3"
                    ></v-img>-->
                  </div>

                  <div
                    class="mb-3 box-contact d-flex align-center"
                    style="justify-content: center;"
                  >
                    <span class="primary--text">Avaliação:</span>
                    <p>{{average_rating}}</p>
                    <v-img :src="require('../../assets/md-star.svg')" width="40px" class="mx-3"></v-img>
                  </div>

                  <div
                    class="mb-3 box-contact d-flex align-center"
                    style="justify-content: center;"
                  >
                    <v-img :src="require('../../assets/icon-money.svg')" width="32px" class="mx-2"></v-img>
                    <span class="mx-2">Valor da Consulta:</span>
                    <p v-if="user.appointment_br_value != '0.00'">R$ {{user.appointment_br_value}}</p>
                    <p v-else>€ {{user.appointment_pt_value}}</p>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col class="col-12 col-md-5 col-lg-5 px-3">
              <div>
                <h3 class="my-4">Área de Atuação</h3>
                <v-row>
                  <v-col
                    class="shrink pa-1 my-2 col-auto"
                    v-for="(especiality,index) in specialities"
                    :key="index"
                  >
                    <span class="specialities">{{especiality.description}}</span>
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <div class="mb-3 box-contact d-flex align-center" v-if="user.opp">
                  <span>OPP:</span>
                  <p>{{ user.opp }}</p>
                </div>
                <div class="mb-3 box-contact align-center" v-if="user.opp">
                  <span>Biografia:</span>
                  <p class="text-justify biographty-text">{{ user.biography }}</p>
                </div>
                <!-- <div class="d-flex mt-4">
                  <v-col xs10 ml-2>
                    <p>
                      <span class="font-weight-bold">Nome: </span>{{ user.contact_name }}
                    </p>
                  </v-col>
                </div>
                <v-divider></v-divider>

                <div class="d-flex mt-4">
                  <v-col xs10 ml-2>
                    <p>
                      <span class="font-weight-bold">Telefone: </span>{{ user.contact_telephone }}
                    </p>
                  </v-col>
                </div>
                <v-divider></v-divider>

                <div class="d-flex mt-4">
                  <v-col xs10 ml-2>
                    <p>
                      <span class="font-weight-bold">Email: </span>{{ user.contact_email }}
                    </p>
                  </v-col>
                </div>
                <v-divider></v-divider>-->
              </div>
            </v-col>
            <!-- <v-col xs12 md4 px-2>
              <h3 class="my-4">Dados Bancários</h3>
              <v-row class="d-flex mt-4">
                <v-col xs3>
                  <v-subheader><span class="font-weight-bold">Banco:</span></v-subheader>
                </v-col>
                <v-col xs9>
                  <v-select
                    :items="items"
                    v-model="banco"
                    hide-details
                    flat
                    solo
                    :disabled="isEdit"
                  ></v-select>
                </v-col>
              </v-row>
              <v-divider></v-divider>

              <v-row class="d-flex mt-4">
                <v-col xs3>
                  <v-subheader><span class="font-weight-bold">Agência:</span></v-subheader>
                </v-col>
                <v-col xs9>
                  <v-text-field
                    hide-details
                    solo
                    flat
                    :disabled="isEdit"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-divider></v-divider>

              <v-row class="d-flex mt-4">
                <v-col xs5>
                  <v-subheader><span class="font-weight-bold">Tipo de Conta:</span></v-subheader>
                </v-col>
                <v-col xs7>
                  <v-select
                    :items="items"
                    v-model="banco"
                    hide-details
                    flat
                    solo
                    :disabled="isEdit"
                  ></v-select>
                </v-col>
              </v-row>
              <v-divider></v-divider>

              <v-row class="d-flex mt-4">
                <v-col xs5>
                  <v-subheader><span class="font-weight-bold">Número da Conta:</span></v-subheader>
                </v-col>
                <v-col xs7>
                  <v-text-field
                    hide-details
                    solo
                    flat
                    :disabled="isEdit"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-divider></v-divider>

              <v-row row wrap justify-space-around mt-3>
                <v-btn color="gray" flat :disabled="isEdit" @click="onEdit(true)">Cancelar</v-btn>
                <v-btn v-if="isEdit" color="gray" dark @click="onEdit(false)">Editar Dados</v-btn>
                <v-btn v-if="!isEdit" color="secondary" dark>Salvar</v-btn>
              </v-row>
            </v-col>-->
          </v-row>
          <!-- <v-row row justify-center my-3 v-if="category == 'psychologist'">
              <v-btn large  color="primary" @click="getOut">
                  <v-icon left dark>exit_to_app</v-icon>
                  Sair
              </v-btn>
          </v-row>-->
        </v-container>
      </v-col>
    </v-row>
  </v-app>
</template>
vuew
<script>
import http from '@/services/httpClient';
import moment from 'moment-timezone';

export default {
  data: () => ({
    user: {},
    cod: '',
    specialities: [],
    banco: [],
    items: [{ text: 'Branco do Brasil' }],
    isEdit: true,
    isLoading: false,
    average_rating: '0/5',
    category: 'psychologist',
  }),
  async mounted() {
    await this.getCod();
    await this.getUser();
    this.getAverage();
  },
  methods: {
    getUser() {
      this.isLoading = true;
      http
        .get(`/psychologists/${this.cod}/`, {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        })
        .then((response) => {
          this.user = response.data;
          this.formatData(this.user.date_birth);
          this.getSpecialities();
        });
    },

    getSpecialities() {
      http
        .get(`/psychologists/${this.cod}/specialities/`, {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        })
        .then((response) => {
          this.specialities = response.data;
        })
        .catch((err) => {
          console.log(err.data);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async getAverage() {
      try {
        const { data, status } = await http.get(
          `/psychologists/${this.cod}/assessments/average/`,
          {
            headers: {
              Authorization: `Token ${localStorage.getItem('user-token')}`,
            },
          },
        );

        if (status == 200) {
          this.average_rating = `${data.average_rating}/5`;
        }
      } catch (error) {
        console.log(error);
      }
    },

    formatData(v) {
      this.user.date_birth = moment(v).format('DD/MM/YYYY');
    },

    getCod() {
      this.category = localStorage.getItem('user-category');
      if (this.category == 'psychologist') {
        this.cod = localStorage.getItem('user-id');
      } else {
        this.cod = this.$route.params.id;
      }
    },

    getOut() {
      localStorage.clear();
      this.$router.replace('/psicologo/login');
    },

    onEdit(value) {
      this.isEdit = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.box-contact {
  background-color: #f7f7f7;
  padding: 16px;
  color: #6f6f6f;
  font-size: 18px;
  flex-wrap: wrap;

  > * {
    flex: 0 0 auto !important;
  }

  p {
    margin: 0;
  }

  span {
    font-size: 20px;
    margin-right: 20px;
    font-weight: bold;
  }
}

h2 {
  color: var(--v-primary-base);
}

.specialities {
  padding: 10px 15px;
  background: green;
  color: white;
  border-radius: 15px;
}

.photoOPP {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-self: center;
  border: solid 1px #707070;
  padding: 32px 16px;
  border-radius: 10px;
}

.biographty-text {
  white-space: pre-wrap;
  p {
    margin-bottom: 0;
  }
}
</style>
